import {FileUpload} from './file-upload';

const initFileUpload = () => {
  const fileUpload = new FileUpload();
  fileUpload.init();
};

export {initFileUpload};
